<template>
  <div style="height:100vh">
    <van-nav-bar
      title="开启储物柜"
      left-text="返回"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />
    <van-button
      color="linear-gradient(to right, #ff6700, #6149f6)"
      style="margin: 100px auto"
      @click="openLocker"
      :loading="loading"
      :disabled="loading"
    >
      OPEN MY LOCKER
    </van-button>
  </div>
</template>

<script>
import { openTheLocker } from '../../api/api-user';

export default {
  data() {
    return {
      loading: false,
      mac: null,
      spot_id: null,
    };
  },
  methods: {
    async openLocker() {
      try {
        // const mac = await this.getMac();
        this.loading = true;
        const path = await openTheLocker(this.mac, this.spot_id);
        if (path) {
          this.$router.go(-1);
        }
        this.loading = false;
      } catch (e) {
        this.$toast.fail(e.message);
      }
    },
  },
  created() {
    if (this.$route.query.mac) {
      this.mac = this.$route.query.mac;
    } else {
      this.$toast.fail('未获取到该用户mac地址');
      this.$router.go(-1);
    }
    // 获取mac
    if (this.$route.query.spot_id) {
      this.spot_id = this.$route.query.spot_id;
    } else {
      this.$toast.fail('未获取到该站SPOT_ID');
      this.$router.go(-1);
    }
  },
};
</script>

<style lang="less" scoped></style>
